"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const assemblerSpeeds = {
    constructer: 0.75,
    assembler: 1.5,
    manufacturer: 2.0,
    "chemical-plant": 1.0,
    "gas-extractor": 1.0,
    "smelter-mk1": 1.0,
    "smelter-mk2": 1.0,
    "oil-pump": 1.0,
    "miner-mk1": 1.0,
    "water-pump-mk1": 1,
    "water-filter": 1,
    greenhouse: 0.5,
    explorer: 2,
    prospector: 1,
    lumberjack: 4,
    "adamantium-drill": 1,
    "rock-crusher": 1,
    centrifuge: 1,
    "lumberjack-school": 1,
    "wind-turbine": 5,
    "coal-power": 100,
    "nuclear-reactor": 2500,
    hydroponics: 5,
    "fire-wizard": 1.0,
    "wizard-paragon": 100.0,
    "arcane-wizard": 1.0,
    "wizard-orb": 2.0,
    "bank": 1.0,
    "desktop-computer": 1,
    "the-spark": 1,
};
const buildingPowerRequirementsPerSecond = {
    "adamantium-drill": { electricity: 100 },
    "chemical-plant": { electricity: 10 },
    "gas-extractor": { electricity: 15 },
    "lumberjack-school": { electricity: 5 },
    "miner-mk1": { electricity: 2 },
    "oil-pump": { electricity: 10 },
    "rock-crusher": { electricity: 20 },
    "smelter-mk1": { wood: 0.1 },
    "smelter-mk2": { electricity: 3 },
    "water-filter": { electricity: 5 },
    "water-pump-mk1": { electricity: 5 },
    assembler: { electricity: 1.5 },
    centrifuge: { electricity: 10 },
    constructer: { electricity: 1 },
    explorer: { electricity: 10 },
    greenhouse: { electricity: 1, fertilizer: 1, "clean-water": 1 },
    manufacturer: { electricity: 2 },
    prospector: { food: 0.05 },
    lumberjack: { food: 0.05 },
    "wind-turbine": {},
    "coal-power": { coal: 1 },
    "nuclear-reactor": { "nuclear-fuel": 0.1 },
    hydroponics: { electricity: 1, fertilizer: 1, "clean-water": 1 },
    "arcane-wizard": { "powerful-mana": 1 },
    "fire-wizard": { "powerful-mana": 1 },
    "wizard-paragon": { "powerful-mana": 2 },
    "wizard-orb": { "powerful-mana": 1, },
    "bank": { "money": 2 },
    "desktop-computer": { electricity: 1 },
    "the-spark": { "wizard-paragon": 0.1, "car": 1, "margarita": 10 },
};
const buildingPowerDisplayWord = {
    prospector: "Food",
    lumberjack: "Food",
    "smelter-mk1": "Fuel",
    "smelter-mk2": "Fuel",
    "bank": "Gold",
    "the-spark": "Inputs",
    "nuclear-reactor": "Fuel",
    "coal-power": "Fuel",
};
/**
 * A list of items that will double building efficiency for each item owned
 */
const buildingBoosts = {
    constructer: "boost-constructor",
    lumberjack: "boost-lumberjack",
    "miner-mk1": "boost-miner-mk1",
    "chemical-plant": "boost-chemical-plant",
    "adamantium-drill": "boost-adamantium-drill",
    "gas-extractor": "boost-gas-extractor",
    "lumberjack-school": "boost-lumberjack-school",
    "oil-pump": "boost-oil-pump",
    "rock-crusher": "boost-rock-crusher",
    "smelter-mk1": "boost-smelter-mk1",
    "smelter-mk2": "boost-smelter-mk2",
    assembler: "boost-assembler",
    "water-pump-mk1": "boost-water-pump",
    centrifuge: "boost-centrifuge",
    explorer: "boost-explorer",
    greenhouse: "boost-greenhouse",
    manufacturer: "boost-manufacturer",
    "fire-wizard": "boost-wizard",
    "arcane-wizard": "boost-wizard",
    "wizard-paragon": "boost-wizard",
    "wizard-orb": "boost-wizard",
    "bank": "boost-bank",
    "desktop-computer": "boost-desktop-computer",
    "the-spark": "the-spark",
};
// keys are the items that do the boosting, not the building.
const buildingBoostTiers = {};
const defaultBuildingBoostTiers = Array(20).map((v, i) => 2 ** i);
const requiredBuildings = {
    youwin: ["the-spark"],
    "the-spark": [],
    "research-the-end": ["by-hand"],
    begin: ["by-hand"],
    prospector: ["by-hand"],
    lumberjack: ["lumberjack-school"],
    "lumberjack-school": ["by-hand", "manufacturer"],
    "research-metal": ["by-hand"],
    "research-small-battery": ["by-hand"],
    "small-battery": ["by-hand", "constructer", "assembler", "manufacturer"],
    electricity: ["wind-turbine", "coal-power", "nuclear-reactor"],
    "wind-turbine": ["by-hand", "constructer", "assembler", "manufacturer"],
    food: ["by-hand", "prospector", "hydroponics"],
    "mystic-coin": [],
    "research-minigames": ["by-hand"],
    "redeem-mc--science5": ["by-hand"],
    "redeem-mc--assembler": ["by-hand"],
    "coal-power": ["by-hand", "manufacturer"],
    "nuclear-reactor": ["manufacturer"],
    money: ["by-hand", "bank"],
    "research-car": ["desktop-computer"],
    "research-marg": ["by-hand"],
    science6: ["by-hand"],
    "adamantium-drill": ["manufacturer"],
    "advanced-circuit": ["assembler", "manufacturer"],
    "crushed-uranium": ["rock-crusher"],
    "nuclear-fuel": ["centrifuge"],
    "": [],
    "iron-frame": ["by-hand", "constructer", "assembler", "manufacturer"],
    "rock-crusher": ["by-hand", "assembler", "manufacturer"],
    "research-adamantium-drill": ["by-hand"],
    "research-aluminum": ["by-hand"],
    "research-arbol": ["by-hand"],
    "research-assembler": ["by-hand"],
    "research-computer": ["by-hand"],
    "research-explorer": ["by-hand"],
    "research-manufacturer": ["by-hand"],
    "research-natural-gas": ["by-hand"],
    "research-nitrogen": ["by-hand"],
    "research-steel": ["by-hand"],
    "research-studonite": ["by-hand"],
    "research-uranium": ["by-hand"],
    "research-fluids": ["by-hand"],
    "research-wire": ["by-hand"],
    "research-oil": ["by-hand"],
    "research-advanced-circuitry": ["by-hand"],
    "research-box": ["by-hand"],
    "research-constructor": ["by-hand"],
    "research-miner-mk1": ["by-hand"],
    "research-frames": ["by-hand"],
    "research-mass-click": ["by-hand"],
    "research-basic-circuit": ["by-hand"],
    "research-woodcutting": ["by-hand"],
    "research-money": ["by-hand"],
    "research-satisfy-button": ["by-hand"],
    "boost-lumberjack": ["by-hand"],
    "boost-miner-mk1": ["by-hand"],
    "boost-chemical-plant": ["by-hand"],
    "boost-adamantium-drill": ["by-hand"],
    "boost-gas-extractor": ["by-hand"],
    "boost-lumberjack-school": ["by-hand"],
    "boost-oil-pump": ["by-hand"],
    "boost-rock-crusher": ["by-hand"],
    "boost-smelter-mk1": ["by-hand"],
    "boost-smelter-mk2": ["by-hand"],
    "boost-assembler": ["by-hand"],
    "boost-water-pump": ["by-hand"],
    "boost-centrifuge": ["by-hand"],
    "boost-explorer": ["by-hand"],
    "boost-greenhouse": ["by-hand"],
    "boost-manufacturer": ["by-hand"],
    "boost-constructor": ["by-hand"],
    "boost-bank": ["by-hand"],
    "boost-desktop-computer": ["by-hand"],
    "research-science-1": ["by-hand"],
    "research-science-2": ["by-hand"],
    "research-science-3": ["by-hand"],
    "research-science-4": ["by-hand"],
    "research-science-5": ["by-hand"],
    "research-science-6": ["by-hand"],
    "research-box2": ["by-hand"],
    "research-box3": ["by-hand"],
    "research-box4": ["by-hand"],
    "research-box5": ["by-hand"],
    "gold-filament": ["assembler", "manufacturer"],
    aluminum: ["smelter-mk2"],
    computer: ["manufacturer"],
    plastic: ["chemical-plant"],
    sand: ["miner-mk1"],
    science0: ["by-hand", "constructer", "assembler", "manufacturer"],
    science1: ["by-hand", "constructer", "assembler", "manufacturer"],
    science2: ["by-hand", "assembler", "manufacturer"],
    science3: ["assembler", "manufacturer"],
    science4: ["manufacturer"],
    science5: ["desktop-computer"],
    seed: ["by-hand"],
    u235: ["centrifuge"],
    centrifuge: ["manufacturer"],
    u234: [],
    slag: [],
    "bauxite-node": ["explorer"],
    "coal-node": ["explorer", "prospector"],
    "copper-node": ["explorer", "prospector"],
    "iron-node": ["explorer", "prospector"],
    "sandy-land": ["explorer", "prospector"],
    "stony-land": ["explorer", "prospector"],
    "wet-land": ["explorer", "prospector"],
    "gold-node": ["explorer"],
    "oil-node": ["explorer"],
    "studonite-node": ["explorer"],
    "uranium-node": ["explorer"],
    // raw
    gold: ["miner-mk1"],
    bauxite: ["adamantium-drill"],
    adamantium: ["chemical-plant"],
    gas: ["gas-extractor"],
    "iron-ore": ["miner-mk1", "by-hand"],
    "copper-ore": ["miner-mk1", "by-hand"],
    "uranium-ore": ["adamantium-drill"],
    water: ["water-pump-mk1"],
    oil: ["oil-pump"],
    "smooth-oil": ["chemical-plant"],
    coal: ["miner-mk1"],
    stone: ["miner-mk1", "by-hand"],
    studonite: ["miner-mk1"],
    // processed raw
    "iron-bar": ["smelter-mk1"],
    "copper-bar": ["smelter-mk1"],
    steel: ["smelter-mk2"],
    sulfur: ["chemical-plant"],
    glass: ["smelter-mk1"],
    "copper-wire": ["by-hand", "constructer", "assembler", "manufacturer"],
    "clean-water": ["water-filter"],
    tree: ["prospector", "greenhouse"],
    wood: ["lumberjack"],
    fertilizer: ["assembler", "manufacturer"],
    nitrogen: ["gas-extractor"],
    // building materials
    gear: ["constructer", "by-hand", "assembler", "manufacturer"],
    pipe: ["constructer", "assembler", "manufacturer"],
    "adamantium-frame": ["assembler", "manufacturer"],
    // advanced materials
    "sulfuric-acid": ["chemical-plant"],
    "basic-circuit": ["assembler", "manufacturer"],
    solvent: ["chemical-plant"],
    // buildings
    "gas-extractor": ["assembler", "manufacturer"],
    manufacturer: ["by-hand", "manufacturer"],
    assembler: ["by-hand", "assembler", "manufacturer"],
    constructer: ["constructer", "assembler", "manufacturer", "by-hand"],
    "chemical-plant": ["assembler", "manufacturer"],
    "miner-mk1": ["constructer", "assembler", "manufacturer"],
    "water-pump-mk1": ["constructer", "assembler", "manufacturer"],
    "oil-pump": ["assembler", "manufacturer"],
    "smelter-mk1": ["by-hand", "constructer"],
    "smelter-mk2": ["constructer", "assembler", "manufacturer"],
    greenhouse: ["assembler", "manufacturer"],
    hydroponics: ["assembler", "manufacturer"],
    "water-filter": ["by-hand", "constructer", "assembler", "manufacturer"],
    explorer: ["assembler", "manufacturer"],
    box: ["by-hand", "constructer", "assembler", "manufacturer"],
    "box-box": ["by-hand", "constructer", "assembler", "manufacturer"],
    box3: ["constructer", "assembler", "manufacturer"],
    box4: ["constructer", "assembler", "manufacturer"],
    box5: ["constructer", "assembler", "manufacturer"],
    tank: ["by-hand", "assembler", "manufacturer"],
    "desk": ["by-hand"],
    "desktop-computer": ["by-hand"],
    "anti-grav-thruster": ["manufacturer"],
    "car-chassis": ["manufacturer"],
    "car-engine": ["manufacturer"],
    "crank-shaft": ["desktop-computer"],
    "engine-block": ["desktop-computer"],
    "engine-electronics": ["manufacturer"],
    "lime-juice": ["hydroponics"],
    "simple-syrup": ["hydroponics"],
    tequila: ["hydroponics"],
    "spark-plug": ["desktop-computer"],
    "steering-wheel": ["desktop-computer"],
    bank: ["by-hand"],
    car: ["by-hand", "manufacturer"],
    chair: ["desktop-computer"],
    margarita: ["by-hand"],
    piston: ["manufacturer"],
    "telescope": ["by-hand"],
    "wizard-pop": ["wizard-paragon", "fire-wizard", "arcane-wizard"],
    "wizard-orb": ["by-hand", "fire-wizard"],
    "raw-mana": ["by-hand", "wizard-orb"],
    "refined-mana": ["by-hand", "wizard-orb"],
    "powerful-mana": ["by-hand", "wizard-orb"],
    "research-paragon": ["by-hand"],
    "research-wizards": ["by-hand"],
    "research-wizard-power": ["by-hand"],
    "arcane-wizard": ["by-hand", "wizard-orb"],
    "fire-wizard": ["by-hand", "wizard-orb"],
    "necro-wizard": ["by-hand", "wizard-orb"],
    "boost-wizard": ["by-hand"],
    "wizard-degree": ["by-hand", "wizard-orb"],
    "wizard-essence": ["by-hand", "wizard-orb"],
    "wizard-paragon": ["by-hand", "wizard-orb"],
    "wizard-power": [],
    'wizard-hut': ["by-hand", "manufacturer"],
    'consume-arcane-wizard': ["by-hand", "wizard-orb"],
    'consume-fire-wizard': ["by-hand", "wizard-orb"],
    'consume-necro-wizard': ["by-hand", "wizard-orb"],
    'consume-wizard-pop': ["by-hand", "wizard-orb"],
    "research-wizard-tower": ["by-hand"],
};
exports.default = {
    assemblerSpeeds,
    requiredBuildings,
    buildingPowerRequirementsPerSecond,
    buildingBoosts,
    buildingPowerDisplayWord,
    buildingBoostTiers,
    defaultBuildingBoostTiers,
};
